import { Record } from 'immutable';

export const Notification = new Record({
  id: null,
  evento: null,
  mensaje: null,
  novedad: null,
  novedadId: null,
  orden: null,
  ordenId: null,
  ordenNro: null,
  practica: null,
  practicaId: null,
  practicaNro: null,
  target: null,
  targetId: null,
  dtCreated: null,
  dtDeleted: null,
  dtEnvio: null,
  dtLectura: null,
  dtUpdated: null,
  isPending:false
});

export function createNotification(data) {
  return new Notification({
    id: data.id,
    evento: data.evento,
    mensaje: data.mensaje,
    novedad: data.novedad,
    novedadId: data.novedadId,
    orden: data.orden,
    ordenId: data.ordenId,
    ordenNro: data.ordenNro,
    practica: data.practica,
    practicaId: data.practicaId,
    practicaNro: data.practicaNro,
    target: data.target,
    targetId: data.targetId,
    dtCreated: data.dtCreated,
    dtDeleted: data.dtDeleted,
    dtEnvio: data.dtEnvio,
    dtLectura: data.dtLectura,
    dtUpdated: data.dtUpdated,
  });
}
